import useDownloadPdf from './useDownloadPdf';

export interface DevisPayload {
  title: string;
  channel: string;
  sendDate: string;
  targetingSummary: string;
  nbRecipients: number | null;
  // Courrier : produits d'affranchissement retenus, les prix sont recalculés par l'API
  postage?: { queryId: number; zoneDelayIds: number[] };
}

export const useDownloadDevis = () => {
  const { download, loading, error } = useDownloadPdf<DevisPayload>(
    '/communication/devis/pdf',
    'devis.pdf',
    'Erreur lors du téléchargement du devis',
  );
  return { downloadDevis: download, loading, error };
};
